/**
 * Component: M51 New Cards 
 * 
 */
'use strict';

export class NewCards
{
  constructor()
  {
    this.selectors = {
      component: $('.js-c-v4-m51-new-cards-slider-wrap'),
      sliders:   $('.js-c-v4-m51-new-cards-slider-wrap .slick-slider')
    };
  }

  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.init_slick_carousel();
  }

  init_slick_carousel()
  {
    this.selectors.sliders.each(function()
    {
      let _sliderNav = $(this).parent().find('.c-v4-m51-new-cards__cards__slick-container');

      // Attach event
      $(this).on('init reInit afterChange', function(event, slick, currentSlide)
      {
        if (slick.slideCount > 1)
        {
          _sliderNav.find('.c-v4--pager').html( ((currentSlide ? currentSlide : 0) + 1) + ' / ' + slick.slideCount );
        }

        // Remove empty ID attributes added by slick slider
        $(this).find("[id]").filter((_, element) => element.id === "").removeAttr("id");

      });

      $(this).slick({
        infinite:       true,
        appendArrows:   _sliderNav,
        slidesToScroll: 1,
        slidesToShow:   2,
        prevArrow:      _sliderNav.find('.c-v4--slick-arrow-left'),
        nextArrow:      _sliderNav.find('.c-v4--slick-arrow-right'),
        variableWidth:  true,
        responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow:   1,
            slidesToScroll: 1,
            variableWidth:  false
          }
        }],
      });
    });
  }
}


